import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors } from '..';
import { FeatureName } from './feature';
import { IAlfrescoDocumentsStoreState } from './state';

export const selectState: MemoizedSelector<object, IAlfrescoDocumentsStoreState> =
	createFeatureSelector<IAlfrescoDocumentsStoreState>(FeatureName);

export const {
	getEntity: getCoordonnesBancairesDocs,
	selectEntity: selectCoordonnesBancairesDocs,
	selectIsLoading: selectCoordonnesBancairesDocsIsLoading,
	selectError: selectCoordonnesBancairesDocsError
} = createEntitySliceSelectors(createSelector(selectState, state => state.coordonneesBancairesDocuments));
